"use client";
import { useGlobalContext } from "@/hooks/useGlobalContext";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Pagination,
  Autoplay,
  Scrollbar,
  A11y,
  Navigation,
} from "swiper/modules";
import { breakpoints } from "@/utils";
import React, { useRef } from "react";
import { Post } from "@/constants/types";
import ActivityCard from "../activity/ActivityCard";
import { useLanguage } from "@/context/LanguageContext";

const UpComingEvent = () => {
  const { upcoming } = useGlobalContext();
  const { t } = useLanguage();
  const prevRef = useRef<HTMLButtonElement | null>(null);
  const nextRef = useRef<HTMLButtonElement | null>(null);

  return (
    upcoming &&
    upcoming.length > 0 && (
      <div className="tp-donate__area p-relative fix">
        <div className="tp-donate__shape-1 d-none d-xxl-block">
          <img src="/assets/img/donate/donate-shape-1-2.png" alt="" />
        </div>
        <div className="tp-donate__shape-2 d-none d-xxl-block">
          <img src="/assets/img/donate/donate-shape-1-3.png" alt="" />
        </div>
        <div className="tp-donate__shape-3 d-none d-lg-block">
          <img src="/assets/img/donate/donate-shape-1-4.png" alt="" />
        </div>
        <div className="tp-donate__bg">
          <div className="container">
            <div className="row align-items-end">
              <div className="col-xl-8 col-lg-8 col-md-8">
                <div className="tp-donate__section-title pb-50">
                  <span className="tp-section-subtitle">
                    {t("UpComingEvents")}
                  </span>
                  <h4 className="tp-section-title">{t("LastEvents")}</h4>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4">
                <div className="tp-donate__section-arrow d-flex justify-content-start justify-content-md-end pb-50">
                  <div className="test-next">
                    <button ref={prevRef}>
                      <i className="far fa-arrow-left"></i>
                    </button>
                  </div>
                  <div className="test-prev">
                    <button ref={nextRef}>
                      <i className="far fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="swiper-container tp-donate__active">
              <Swiper
                className="swiper-wrapper"
                spaceBetween={20}
                breakpoints={breakpoints}
                modules={[Autoplay, Pagination, Scrollbar, A11y, Navigation]}
                loop={true}
                autoplay={{ delay: 3000 }}
                pagination={{ clickable: true }}
                navigation={{
                  prevEl: prevRef.current,
                  nextEl: nextRef.current,
                }}
                speed={2000}
                onSwiper={(swiper: any) => {
                  setTimeout(() => {
                    if (swiper.params?.navigation) {
                      swiper.params.navigation.prevEl = prevRef.current;
                      swiper.params.navigation.nextEl = nextRef.current;
                      swiper.navigation.init();
                      swiper.navigation.update();
                    }
                  });
                }}
              >
                {upcoming?.map((event: Post, index: number) => (
                  <SwiperSlide key={index}>
                    <ActivityCard col={12} post={event} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default UpComingEvent;
